import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import './Header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const roles = [
  'Problem Solver.',
  'Systems Thinker.',
  'Community Builder.',
];

const Header = () => {
  const [roleIndex, setRoleIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentRole = roles[roleIndex];
    let timeout;

    if (!isDeleting && displayText === currentRole) {
      timeout = setTimeout(() => setIsDeleting(true), 2000);
    } else if (isDeleting && displayText === '') {
      setIsDeleting(false);
      setRoleIndex((prev) => (prev + 1) % roles.length);
    } else if (isDeleting) {
      timeout = setTimeout(() => {
        setDisplayText(currentRole.substring(0, displayText.length - 1));
      }, 50);
    } else {
      timeout = setTimeout(() => {
        setDisplayText(currentRole.substring(0, displayText.length + 1));
      }, 100);
    }

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, roleIndex]);

  return (
    <div className="app__header app__flex">
      <div className="app__header-top">
          <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
          className="app__header-info"
        >
          <div className="app__header-terminal">
            <div className="terminal__header">
              <div className="terminal__buttons">
                <span className="terminal__btn terminal__btn--red" />
                <span className="terminal__btn terminal__btn--yellow" />
                <span className="terminal__btn terminal__btn--green" />
              </div>
              <span className="terminal__title">matthew@portfolio ~ %</span>
            </div>
            <div className="terminal__body">
              <p className="terminal__line">
                <span className="terminal__prompt">$ </span>
                <span className="terminal__command">whoami</span>
              </p>
              <p className="terminal__output">Hi, My name is <span className="terminal__name">Matthew So</span></p>
              <p className="terminal__output">Computer Engineering @ UWaterloo</p>
              <p className="terminal__line terminal__line--active">
                <span className="terminal__prompt">$ </span>
                <span className="terminal__command">echo $ROLE</span>
              </p>
              <p className="terminal__output">
                I am a <span className="terminal__role">{displayText}</span>
                <span className="terminal__cursor">|</span>
              </p>
              <p className="terminal__line terminal__line--active">
                <span className="terminal__prompt">$ </span>
                <span className="terminal__command">cat interests.tech</span>
              </p>
              <p className="terminal__output">ML Infrastructure &middot; Distributed Systems</p>
              <p className="terminal__output">Inference Optimization &middot; Computer Networks</p>
              <p className="terminal__line terminal__line--active">
                <span className="terminal__prompt">$ </span>
                <span className="terminal__command">cat interests.life</span>
              </p>
              <p className="terminal__output">Basketball &middot; Chess &middot; Concerts &middot; Game Theory</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          whileInView={{ opacity: [0, 1], scale: [0.92, 1] }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        className="app__header-photo"
      >
          <img src={images.profile2} alt="Matthew So" />
        </motion.div>
      </div>

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {[images.java, images.python, images.cpp].map((circle, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="tech_stack" />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, 'home');
